import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import '../styles/AudioToggle.css';

const AudioToggle = ({ audioEnabled, onToggle }) => {
  return (
    <button 
      className="audio-toggle"
      onClick={onToggle}
      title={audioEnabled ? 'Desactivar audio' : 'Activar audio'}
    >
      <span className="audio-icon">
        {audioEnabled ? <Volume2 size={24} /> : <VolumeX size={24} />}
      </span>
    </button>
  );
};

export default AudioToggle;
